import React from 'react'

const SvgAppleFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.03 2.22a.75.75 0 010 1.06c-.469.47-.81 1.453-.947 2.798-.132 1.3-.055 2.776.157 4.049a.75.75 0 11-1.48.246c-.23-1.383-.316-2.993-.17-4.447.144-1.41.523-2.848 1.38-3.706a.75.75 0 011.06 0z'
    />
    <path d='M14.599 4.047a3.138 3.138 0 00-1.002 1.08 16.312 16.312 0 00-.785 1.636c-.558 1.316.543 1.187 1.958.987.65-.201 1.94-.453 2.476-.738 2.644-1.412.532-5.054-2.647-2.965z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M19.632 7.584C21.102 8.858 22 10.664 22 12.938c0 3.77-2.484 7.676-6.177 9.083-1.147.436-2.228.14-2.752-.007a71.992 71.992 0 01-.41-.117c-.381-.11-.51-.146-.66-.146l-.023.001-.07.008a3.497 3.497 0 00-.25.046c-.149.032-.277.064-.433.102-.103.025-.216.054-.356.087a8.2 8.2 0 01-1.08.194c-.388.038-.931.05-1.5-.13C4.154 20.76 2 16.76 2 12.94c0-2.708 1.272-4.751 3.267-6.025.948-.604 2.114-1.235 3.304-1.602.583-.18 1.093.285 1.052.893-.064.964-.12 2.237.074 2.847.286.895 2.084 1.882 3.546.308.175-.189.398-.331.65-.378 1.46-.27 3.287-.75 4.426-1.416.413-.242.951-.296 1.313.018z'
    />
  </svg>
)

export default SvgAppleFilled
